export default __webpack_public_path__ + "static/media/dm_nguon_khach_mau.31ac3d74.xlsx";